import { CalendarCheck, CalendarDots, UserCircle } from "@phosphor-icons/react";

import Skeleton from "common/components/ui/Skeleton";
import { formatDate, formatTimestamp } from "common/helpers/utils";

import useLinkedInEventDetails from "../../../datahooks/useLinkedInEventDetails";
import GroupOrEventHeading from "../GroupOrEventHeading";
import PreviewItemRow from "../PreviewItemRow";

import type { LinkedInEvent } from "../../../types";

interface SelectedEventProps {
  accountId: string;
  event: LinkedInEvent;
}

export default function SelectedEvent({
  accountId,
  event,
}: SelectedEventProps) {
  const { id, images, name, description } = event;

  const { linkedInEvent, isLoadingLinkedInEvent } = useLinkedInEventDetails(
    accountId,
    id,
  );

  let eventDateString = "";

  if (linkedInEvent) {
    const { time_range } = linkedInEvent;

    const startDate = new Date(time_range.start);
    const endDate = new Date(time_range.end);

    eventDateString = formatDate(time_range.start);

    if (
      (startDate.getDate() === endDate.getDate() &&
        startDate.getMonth() === endDate.getMonth() &&
        startDate.getFullYear() === endDate.getFullYear()) ||
      !time_range.end
    ) {
      let timeString = formatTimestamp(time_range.start);
      if (time_range.end) {
        timeString += `- ${formatTimestamp(time_range.end)}`;
      }
      eventDateString += ` (${timeString})`;
    } else if (time_range.end) {
      eventDateString += `- ${formatDate(time_range.end)}`;
    }
  }

  const eventItems = [
    {
      icon: CalendarCheck,
      label: "Is attending",
      value: linkedInEvent?.status || "",
    },
    {
      icon: UserCircle,
      label: "Organizer",
      value: linkedInEvent?.organizer.name || "",
    },
    {
      icon: CalendarDots,
      label: "Event date",
      value: eventDateString,
    },
  ];

  return (
    <>
      <GroupOrEventHeading
        title={name}
        subtitle={description}
        imageSrc={images.length ? images[0].url : undefined}
      />
      <div className="flex flex-col">
        {eventItems.map(({ icon: Icon, label, value }) => (
          <PreviewItemRow key={label} icon={Icon} label={label}>
            <div className="rounded-2xl px-3 py-1.5 bg-black-100 text-button-sm capitalize">
              {isLoadingLinkedInEvent ? (
                <Skeleton className="w-9 h-5" />
              ) : (
                value
              )}
            </div>
          </PreviewItemRow>
        ))}
      </div>
    </>
  );
}
